export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, interactive-widget=overlays-content"},{"name":"color-scheme","content":"light"},{"hid":"description","name":"description","content":"Социальная сеть для активных команд"},{"property":"og:site_name","content":"КВЕСТ"},{"property":"og:locale","content":"ru_RU"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https://new.queststore.space/"},{"hid":"og:image:secure_url","property":"og:image:secure_url","content":"/preview.png"},{"hid":"og:title","property":"og:title","content":"КВЕСТ"},{"hid":"og:description","property":"og:description","content":"Социальная сеть для активных команд"},{"hid":"og:image","property":"og:image","content":"/preview.png"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"628"},{"property":"og:image:alt","content":"Социальная сеть для активных команд"},{"name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:url","name":"twitter:url","content":"https://new.queststore.space/"},{"hid":"twitter:title","name":"twitter:title","content":"КВЕСТ"},{"hid":"twitter:description","name":"twitter:description","content":"Социальная сеть для активных команд"},{"hid":"twitter:image","name":"twitter:image","content":"/preview.png"},{"name":"author","content":"Социальная сеть для активных команд"},{"name":"robots","content":"index, follow"}],"link":[{"rel":"stylesheet","href":"/fonts/index.css"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon.svg"},{"rel":"canonical","href":"https://new.queststore.space/"}],"style":[],"script":[],"noscript":[],"title":"КВЕСТ","titleTemplate":"%s"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false